'use strict';

import angular from 'angular';
var localisations = require('../account.localisations');

export default class SignupController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {};
  submitted = false;

  /*@ngInject*/
  constructor(Auth, $location, common) {
    this.Auth = Auth;
    this.$location = $location;
    this.common = common;
    this.common.setPageTitle('');
    this.common.showNavbar(true);
    this.common.setBack(null, null);
    this.localisations = localisations[this.common.getLocale()];
    this.registerRunning = false;
    this.signedUp = false;
    this.readHouseRules = false;
    this.readingHR = false;
    this.agreedHR = false;
  }

  showRules() {
    console.log('Showing Rules');
    this.readingHR = true;
    this.readHouseRules = true;
  }

  hideRules() {
    this.readingHR = false;
  }

  register(form) {
    this.submitted = true;

    if(form.$valid && !this.registerRunning && this.agreedHR && this.readHouseRules) {
      this.registerRunning = true;
      return this.Auth.createUser({
        name: this.user.name,
        email: this.user.email,
        password: this.user.password,
        role: 'user'
      })
        .then(() => {
          // Account created, redirect to home
          //this.$location.path('/dashboard');
          this.signedUp = true;
          this.registerRunning = false;
        })
        .catch(err => {
          this.registerRunning = false;
          err = err.data;
          this.errors = {};
          // Update validity of form fields that match the mongoose errors
          angular.forEach(err.errors, (error, field) => {
            form[field].$setValidity('mongoose', false);
            this.errors[field] = error.message;
          });
        });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/signup/signup.controller.js